import { useState } from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`nav w-nav ${isMenuOpen ? 'is-open' : ''}`} role="banner">
      <div className="container-full is-flex-nav">
        <a href="https://uselima.com" className="brand w-nav-brand">
          <img
            src="/images/lima-logomark-1_1lima-logomark-1.avif"
            loading="lazy"
            width={50}
            alt="Lima shimmering logo"
            className="nav-logo is-icon"
          />
          <img
            src="/images/lima-wordmark.svg"
            loading="lazy"
            width={54}
            alt="Lima logo (wordmark)"
            className="nav-logo is-dark"
          />
        </a>
        <div className={`nav-menu is-lp-nav w-nav-menu ${isMenuOpen ? 'is-open' : ''}`}>
          <a
            href="https://uselima.com/frequently-asked-questions"
            className="nav-link w-nav-link"
            onClick={closeMenu}
          >
            FAQs
          </a>
          <a 
            href="https://uselima.com/pricing" 
            className="nav-link w-nav-link"
            onClick={closeMenu}
          >
            Pricing
          </a>
          <Link to="/login" className="nav-link w-nav-link" onClick={closeMenu}>
            Login
          </Link>
          <Link to="/signup" className="button is-nav-button w-button" onClick={closeMenu}>
            Get started
          </Link>
        </div>
        <div 
          className={`menu-button w-nav-button ${isMenuOpen ? 'is-open' : ''}`}
          onClick={toggleMenu}
          style={{ cursor: 'pointer' }}
        >
          <div className={`menu-line is-dark-line ${isMenuOpen ? 'is-open' : ''}`}></div>
          <div className={`menu-line-middle is-dark-line ${isMenuOpen ? 'is-open' : ''}`}></div>
          <div className={`menu-line-bottom is-dark-line ${isMenuOpen ? 'is-open' : ''}`}></div>
        </div>
      </div>
    </nav>
  );
}
